import i18n from 'i18next';
import { getOperators } from './RuleServiceV2.const';

export function validateCriteriaTypes(data: any) {
    let isValid = true;
    let messages = [] as any[];
    if (!data.Key) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.key.validationMessage`));
        isValid = false;
    }
    if (!data.Name) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.name.validationMessage`));
        isValid = false;
    }
    if (
        data.hasPredefinedValue &&
        (data.criteriaTypeValues.length <= 0 ||
            data.criteriaTypeValues.some((k: any) => k.Name === '' || k.Value === ''))
    ) {
        messages.push(i18n.t(`ruleManagement.fields.criteriaType.hasPredefinedValue.validationMessage`));
        isValid = false;
    }
    return {
        isValid,
        messages,
    };
}

export function validateRuleTemplate(data: any) {
    let isValid = true;
    let messages = [] as any[];

    if (!data.Name) {
        messages.push(i18n.t(`ruleManagement.fields.ruleTemplate.name.validationMessage`));
        isValid = false;
    }

    if (
        data.criteriaTypeValues?.length <= 0 ||
        data.criteriaTypeValues?.some((k: any) =>
            [k.CriteriaTypeId, k.Operator].some((value) => value === null || value === undefined || value === '')
        )
    ) {
        messages.push(i18n.t(`ruleManagement.fields.ruleTemplate.criteriaType.validationMessage`));
        messages.push(i18n.t(`ruleManagement.fields.ruleTemplate.operator.validationMessage`));
        isValid = false;
    }

    return {
        isValid,
        messages,
    };
}

export function getRegionId() {
    return JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId?.toString();
}

export function getCountryCode() {
    return JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryCode;
}

export function validateRule(data: any) {
    let isValid = true;
    let messages = [] as any[];
    const operators = getOperators();

    if (!data.ruleTemplateId) {
        messages.push(i18n.t(`ruleManagement.fields.rule.ruleTemplate.validationMessage`));
        isValid = false;
    }
    if (!data.ruleKey) {
        messages.push(i18n.t(`ruleManagement.fields.rule.ruleKey.validationMessage`));
        isValid = false;
    }
    if (!data.action) {
        messages.push(i18n.t(`ruleManagement.fields.rule.action.validationMessage`));
        isValid = false;
    }
    (data.criteria || [])?.forEach((item: any, index: any) => {
        if (item.key === '') {
            messages.push(i18n.t(`ruleManagement.fields.criteriaType.hasPredefinedValue.validationMessage`));
            isValid = false;
            return;
        }
        if (item.operator === operators?.[0].value || item.operator === operators?.[5].value) {
            if (item.value === '*') {
                return;
            }
            if (!item.value && !data.selectedAllIndex?.[index]?.disabled) {
                messages.push(i18n.t(`ruleManagement.fields.rule.criteria.criteriaFieldMissing`));
                isValid = false;
            }
        }
    });
    const uniqueMessages = Array.from(new Set(messages));
    return {
        isValid,
        messages: uniqueMessages,
    };
}
